import Icon from "./IconBase.js";
const BatchIcon = (props) => {
  return (
    <Icon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      style={{ borderColor: "white" }}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.419 15.7321C21.419 19.3101 19.31 21.4191 15.732 21.4191H7.95C4.363 21.4191 2.25 19.3101 2.25 15.7321V7.93209C2.25 4.35909 3.564 2.25009 7.143 2.25009H9.143C9.861 2.25109 10.537 2.58809 10.967 3.16309L11.88 4.37709C12.312 4.95109 12.988 5.28909 13.706 5.29009H16.536C20.123 5.29009 21.447 7.11609 21.447 10.7671L21.419 15.7321Z"
          stroke="#757575"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.48096 14.463H16.216"
          stroke="#757575"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
};
export default BatchIcon;
